/**
 * src/lib/voice/convertProjectFilter.js
 *
 * CEO 2026-06-22: the voice action → task Convert form's Project dropdown listed
 * closed / finalized / legacy boats, cluttering it. It must show ACTIVE projects
 * only — EXCEPT the note's own (seeded/selected) project, which stays visible even
 * if it's legacy (the "I uploaded the note directly inside a legacy project" case).
 *
 * Reuses the canonical lifecycle predicate isInactiveLifecycle() (single source of
 * truth, tested in tests/hooks/projects-lifecycle-filter.test.js): a project is
 * inactive when status ∈ {legacy, closed, completed, archived} OR its terminal
 * kanban stage is Finalized/Closed.
 *
 * Pipeline (deal) notes are intentionally unaffected: a deal-note action attaches
 * its task to the DEAL server-side, and the Project field stays an optional override
 * ("No project" is correct for a sales lead that isn't a project yet).
 */
import { isInactiveLifecycle } from '../../hooks/useProjectsFiltering';

/**
 * @param {Array<object>} projects   all projects (flat snake_case rows)
 * @param {string} [selectedId]      the currently-selected/seeded project id (kept always)
 * @returns {Array<object>} active projects + the selected one, in input order
 */
export function visibleConvertProjects(projects = [], selectedId = '') {
  return (projects || []).filter(
    (p) => p.id === selectedId || (!p.archived_at && !isInactiveLifecycle(p)),
  );
}

export default visibleConvertProjects;
